// extracted by mini-css-extract-plugin
export default {"container":"d3214437"};